import { render, staticRenderFns } from "./ResearchYear.vue?vue&type=template&id=23e96f8d"
import script from "./ResearchYear.vue?vue&type=script&lang=js"
export * from "./ResearchYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e96f8d')) {
      api.createRecord('23e96f8d', component.options)
    } else {
      api.reload('23e96f8d', component.options)
    }
    module.hot.accept("./ResearchYear.vue?vue&type=template&id=23e96f8d", function () {
      api.rerender('23e96f8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/ResearchYear.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchYear.vue
// module id = 412
// module chunks = 0